<template>
    <div class="content">
        <div class="yokuaruQ_box">
            <h1>よくある質問</h1>

            <navi>
                <ul class="nav_list">
                    <li class="nav_item" @click="handleOpenQA(1)">どんなことを学ぶの？</li>
                    <li class="nav_item" @click="handleOpenQA(2)">どんな人が向いていますか。</li>
                    <li class="nav_item" @click="handleOpenQA(3)">働きやすさは？残業は？</li>
                    <li class="nav_item" @click="handleOpenQA(4)">給料は？</li>
                    <li class="nav_item" @click="handleOpenQA(5)">どんな人が多い？</li>
                    <li class="nav_item" @click="handleOpenQA(6)">どんなキャリアを選べる？</li>
                    <li class="nav_item" @click="handleOpenQA(7)">やりがいは？</li>
                    <li class="nav_item" @click="handleOpenQA(8)">どんな仕事をしている？</li>
                </ul>
            </navi>
        </div>

        <div class="yokuaruA_box" id="answer_box">
            <div class="answer_frame" v-if="isOpenQA1">
                <h1>研修ではどんなことを学ぶの？</h1>
                <p>研修では、ソフトウェアの制作の大まかな全体像を知り、現場だけでは気付けない
                    俯瞰的な視点でソフトウェアとそこで必要とされる技術を学びます。
                    また並行して、開発現場で実践的に使える内容も学んでいきます。
                </p>
                <img src="" alt="">
            </div>

            <div class="answer_frame" v-if="isOpenQA2">
                <h1>どんな人が向いていますか。</h1>
                <p>MIKには、社員本人の興味・関心や、お客様先の需要に応じて様々な分野で仕事をしていただいています。
                    半導体関連や、ドローン、通信事業者など、ITに関連する多くのお客様先で仕事を行なっています。
                    その仕事内容は、プログラミムを書くことだけではありません。
                    むしろ、ITの現場はプログラムを書くことは全体の30％程度。
                    お客様先の担当者と打ち合わせをしたり、ご説明をしたり、
                    制作物に関する説明資料を用意したりと、
                    プログラムそのものより、自分が製作したものや改修したものについて、
                    お客様に「理解してもらう」という過程が重要です。

                    もちろん知識が豊富で綺麗なプログラムを書けることも重要ですが、
                    ITの現場は組織なので、人との関わりが得意な人が実は一番重宝されたりします。
                </p>
                <img src="" alt="">
            </div>

            <div class="answer_frame" v-if="isOpenQA3">
                <h1>働きやすさは？残業は？</h1>
                <p>MIKの平均残業時間は最大15時間程度。
                    中には、ほとんど残業がない方も。
                    まず、世間でよく言われているような、寝る間も惜しんでプログラムを書き続ける過酷な職場で働いている
                    方はMIKにはいません。

                    年間の休みも120日程度あり、有給は前日までの申請ですぐに取得できますし、
                    有給申請も、弊社の独自Webアプリからポチるだけで簡単に、申請できます。

                    困ったことがあれば弊社の営業担当がすぐに相談に乗れる体制をとっていますし、
                    お客様先に言いにくいことがあれば、営業担当経由で対応することもあります。

                    未経験や経験年数の浅い方については、弊社社員で構成したチームでのお仕事の中で、
                    現場を経験いただき、実践の中で開発のお仕事を一人でも進められるよう支援を行なっています。

                    また、お客様状況により、チームへの配属が難しい場合においても、
                    しっかり教育を行なっていただけるお客様先に配属するなど、
                    配属後に一人で右も左もわからず困ってしまうことがないよう、しっかりと配慮の上配属を行なっています。


                </p>
                <img src="" alt="">
            </div>

            <div class="answer_frame" v-if="isOpenQA4">
                <h1>お給料は？</h1>
                <p>MIKの基本理念は、エンジニアファースト。
                    「エンジニアさんに優しい会社を作りたい」という弊社の現社長の強い意志のもと、
                    MIKはこれまでやってきました。
                    この考えは、給与に最も反映されており、エンジニアさんにできるだけ還元できるように、
                    という想いで給与を設定しています。
                    このため同じ技術職として他のエンジニア派遣企業から弊社に転職されてきた方は、
                    弊社に移ってから給与が増えたという事例が多くあります。
                </p>
            </div>


            <div class="answer_frame" v-if="isOpenQA5">
                <h1>どんな人が多い？</h1>
                <p>MIKには現在70名程度の社員さんがいますので、もちろんいろんな方がいますが、基本的には誠実で真面目な方が多い印象です。
                    20代、30代が多く、若い社員が多い会社ではありますが、とても勉強熱心だったり、向上心の高い若手社員が多く、将来性を感じます。
                    また、40代、50代の中堅・ベテラン層は、黙々と仕事をされている方が多い印象で、
                    面倒見が良く、かつ仕事ができるアニキ・アネキタイプがチームの中心にいるので、
                    各チーム安定したパフォーマンスを出してくれています。
                </p>
            </div>

            <div class="answer_frame" v-if="isOpenQA6">
                <h1>どんなキャリアを選べるの？</h1>
                <p>MIKでは、まずエンジニアとして一人前になっていただき、どんな現場でも通用する力をつけていただくことを
                    第一目標としています。
                    エンジニアとして一人でも仕事ができるようになってきたら、新人さんの教育係として仕事を教えたり、
                    研修の講師となっていただいたりしながら、技術と教える力、フォローする力をしっかり蓄えていく段階があります。
                    実力がついたと判断できれば、チームリーダーとして、MIKのチームを一つおまかせするような段階にも入っていきます。
                    また、別の道としてはMIKの内部に入り、技術力を活かした営業を行ったり、現場経験で培ったコミュニケーション力を活かして、エンジニアさんの
                    精神的なフォローを行う方向に進む方、社内システム構築や広報といったお仕事をしていく方向に進む可能性もあります。
                    そして、弊社は副業OK。
                    会社の中に留まることなく、いろいろな世界で活躍する人を応援したいという社風でもあります。
                    例えば起業を考えたり、フリーになって仕事をしたい、といった方も応援したいのがMIKです。
                    「エンジニア」という小さな視点にとらわれず、「ITを使いこなせるようになって何をしよう」と考えれば、
                    キャリアは自分次第で無限に作って行けるもの、というのがMIKの考えです。
                </p>
            </div>

            <div class="answer_frame" v-if="isOpenQA7">
                <h1>やりがいは？</h1>
                <p>MIKでは月に1回程度、社員さん同士で交流できるような交流会を行うのですが、その中では
                    今対応している仕事に迷い、悩みながらも活き活きとお仕事をされている姿が印象的です。
                    交流会では、社内の愚痴や悪口ではなく、どうやって仕事を進めたらうまくいきやすいか、
                    どんな心構えなら楽しく、ラクに仕事を進められるか、といった悩んでいる若手社員たちの視野が明るくなるような
                    話題で盛り上がっています。
                    若手社員、中堅社員、ベテラン社員がその場その場で自分の役割を認識し、やりがいを持ってその仕事に取り組んでいるからこそ
                    できる発言の一つ一つが、皆さんの「やりがい」を表しているな、と感じます。
                </p>
            </div>

            <div class="answer_frame" v-if="isOpenQA8">
                <h1>どんな仕事をしているの？</h1>
                <p>MIKでは、サーバー、API、データベースといったバックエンド寄りの対応をされている方が多く、
                    フロントエンド業務は少なめです。
                    言語は、JAVA、C、C#といった基本的な言語を使用している開発現場が多くなっています。
                    大規模なシステムの改修や機能追加を行っている方、テスト業務を主に行っている方、設計工程でお客様企業に
                    技術的アドバイスを行っている方、運用工程において、エンドユーザーに使用方法を説明する業務を行っている方など、
                    対応している工程はさまざまです。
                </p>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            isOpenQA1: false,
            isOpenQA2: false,
            isOpenQA3: false,
            isOpenQA4: false,
            isOpenQA5: false,
            isOpenQA6: false,
            isOpenQA7: false,
            isOpenQA8: false,

        }

    },
    methods: {
        scrollToSection(id) {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'auto' })
            }
        },
        handleOpenQA(q_num) {
            switch (q_num) {
                case 1:
                    this.isOpenQA1 = !this.isOpenQA1;
                    this.isOpenQA2 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA8 = false;
                    break;
                case 2:
                    this.isOpenQA2 = !this.isOpenQA2;
                    this.isOpenQA1 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA8 = false;
                    break;
                case 3:
                    this.isOpenQA3 = !this.isOpenQA3;
                    this.isOpenQA2 = false;
                    this.isOpenQA1 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA8 = false;
                    break;
                case 4:
                    this.isOpenQA4 = !this.isOpenQA4;
                    this.isOpenQA2 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA1 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA8 = false;
                    break;
                case 5:
                    this.isOpenQA5 = !this.isOpenQA5;
                    this.isOpenQA2 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA1 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA8 = false;
                    break;
                case 6:
                    this.isOpenQA6 = !this.isOpenQA6;
                    this.isOpenQA2 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA1 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA8 = false;
                    break;
                case 7:
                    this.isOpenQA7 = !this.isOpenQA7;
                    this.isOpenQA2 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA1 = false;
                    this.isOpenQA8 = false;
                    break;
                case 8:
                    this.isOpenQA8 = !this.isOpenQA8;
                    this.isOpenQA2 = false;
                    this.isOpenQA3 = false;
                    this.isOpenQA4 = false;
                    this.isOpenQA5 = false;
                    this.isOpenQA6 = false;
                    this.isOpenQA7 = false;
                    this.isOpenQA1 = false;
                    break;
                default:
                    break;

            }
            this.scrollToSection('answer_box');
        }
    }

}
</script>
<style scoped>
.answer_frame {
    width: 700px;
    line-height: 40px;

}

.nav_item {
    cursor: pointer;
}

.nav_item:hover {
    background-color: deepskyblue;
    color: #fff;
    border: 1px solid #fff;

}

.yokuaruQ_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

@media(max-width:500px) {
    .nav_list {
        display: flex;
        flex-direction: column;
    }

    .yokuaruQ_box {
        display: flex;
        flex-direction: column;

    }

    .answer_frame {
        width: 350px;
        padding: 0 30px;
    }

    .content {
        display: flex;
        flex-direction: column;
    }

    .yokuaruA_box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .answer_frame {
        width: 300px;
        padding: 10px
    }

}
</style>